import URI from "urijs";
import { Envs, UserLanguage } from "../@types";
import { UserToQueryStringLangMap } from "./CONSTANTS";

export const getEnvironment = (): Envs => {
  const hostname = window.location.hostname;
  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    return Envs.local;
  }

  if (hostname.includes("test")) {
    return Envs.test;
  }

  if (hostname.includes("imp")) {
    return Envs.imp;
  }

  return Envs.prod;
};

export const getLinkWithLanguage = (
  url: string,
  language: UserLanguage
): string => {
  return `https://${language === UserLanguage.SPANISH ? "es" : "www"}.${url}`;
};

export const getLinkWithLanguageAndEnvironment = (
  url: string,
  language: string
): string => {
  const environment = getEnvironment();
  const subdomainMap = {
    [Envs.local]: "test.",
    [Envs.test]: "test.",
    [Envs.imp]: "imp.",
    [Envs.prod]: "www.",
  };
  const subdomain = subdomainMap[environment];
  const link = new URI(`https://${subdomain}${url}`);

  link.addQuery("lang", UserToQueryStringLangMap[language]);

  return link.toString();
};
